import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskLines } from "./Reveal";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Fil d'Ariane" className="text-xs text-slate-500" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((it, i) => (
          <li key={it.to} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3 w-3" />}
            {i < items.length - 1 ? <Link to={it.to} className="hover:text-ag-blue">{it.label}</Link> : <span aria-current="page" className="text-slate-700">{it.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function PageHero({ eyebrow, title, intro, crumbs, children, image, imageAlt }) {
  return (
    <section className="relative overflow-hidden bg-ag-mist px-5 pb-16 pt-32 lg:px-8 lg:pb-24 lg:pt-40" data-testid="page-hero">
      <div className="pointer-events-none absolute -right-48 -top-24 h-[640px] w-[640px] rounded-full border border-dashed border-ag-blue/20" />
      <div className="mx-auto grid max-w-[1320px] items-center gap-12 lg:grid-cols-12">
        <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
          {crumbs && <Breadcrumbs items={crumbs} />}
          <p className="eyebrow mt-6">{eyebrow}</p>
          <h1 className="mt-4 font-display text-4xl font-extrabold leading-[0.98] tracking-tight text-ag-ink sm:text-5xl lg:text-6xl" data-testid="page-h1">
            <MaskLines lines={[title]} />
          </h1>
          {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">{intro}</p>}
          {children && <div className="mt-8">{children}</div>}
        </div>
        {image && (
          <div className="lg:col-span-5">
            <div className="windshield-frame aspect-[4/3] w-full overflow-hidden bg-ag-ink">
              <img src={image} alt={imageAlt} className="h-full w-full object-cover" fetchpriority="high" width="1400" height="1050" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
